<template>
  <div class="problems-select-block" @mouseenter="enablePron" @mouseleave="disablePron">
    <div class="pron" v-if="showPron">
      <span v-for="(p, wordIndex) in pron" style="margin:0 2px">
        <span
          v-for="(s, index) in p"
          :key="index"
          :class="{'target-phoneme': stressed[wordIndex][index]}"
        >{{s.withStress}}</span>
      </span>
    </div>
    <div :class="{ 'hide': showPron}" class="text">{{problem.word}}</div>
    <div class="difficulty">
      <span class="star" v-for="i in 5" :key="i">
        <span v-show="i <= problem.difficulty">★</span>
      </span>
    </div>
    <transition name="fade">
      <div
        v-show="!cleared(accessibleScore) &&  accessibleScore!== null"
        class="score"
      >{{Math.ceil(score)+'点'}}</div>
    </transition>
    <transition name="fade">
      <div
        v-if="accessibleScore!==null && cleared(accessibleScore) "
        class="score"
      >クリア済 {{Math.ceil(accessibleScore)}}点</div>
    </transition>
    <transition name="fade">
      <div v-show="score === undefined">
        <div class="score">未トライ</div>
      </div>
    </transition>

    <div
      class="progress"
      :style="`width: ${score ? score : 0}%`"
      :class="{ 'cleared': cleared(score)}"
    ></div>
  </div>
</template>

<script>
import { CLEAR_SCORE } from "@/constants";
import pronDict from "@/utils/PronDictionary";

export default {
  components: {
    // PronConverter: require("@/components/Language/PronConverter").default
  },
  props: ["problem", "targetPhoneme", "score", "selectedLesson"],
  data() {
    return {
      red: true,
      showPron: false,
      activeTraining: false,
      pron: [],
      stressed: [],
      pronLoaded: false
    };
  },
  computed: {
    accessibleScore() {
      if (this.score) {
        return this.score.score;
      } else {
        return null;
      }
    }
  },
  methods: {
    cleared(score) {
      return score >= CLEAR_SCORE;
    },
    enablePron() {
      let self = this;
      this.showPron = true;
      if (!this.pronLoaded) {
        pronDict.getIpaFromSingleText(this.problem.word).then(result => {
          const pron = result.map(word => {
            if (word) {
              return word.map(ph => {
                return ph;
              });
            }
          });
          this.pron = pron;

          let targetPhoneme = this.selectedLesson.targetPhoneme;

          let stressedArray = [];
          pron.forEach(wordPron => {
            let stressed = [];
            if (wordPron) {
              for (let index = 0; index < wordPron.length; index++) {
                if (wordPron[index].withoutStress === targetPhoneme) {
                  stressed[index] = true;
                } else {
                  stressed[index] = false;
                }
                // For irregular pattern schwa
                if (targetPhoneme === "ʌ") {
                  if (
                    (wordPron[index].withoutStress === "ə" &&
                      wordPron[index].withStress === "ʌ́") ||
                    (wordPron[index].withoutStress === "ə" &&
                      wordPron[index].withStress === "ʌ̀")
                  ) {
                    stressed[index] = true;
                  }
                }
              }
            }

            stressedArray.push(stressed);
          });
          self.stressed = stressedArray;
        });
      }
    },
    disablePron() {
      this.showPron = false;
    }
  }
};
</script>


<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.accented {
  color: #f88 !important;
}
.problems-select-block {
  z-index: 30;
  padding: relative;
  display: inline-block;
  cursor: pointer;
  margin: 15px 20px 0 0;
  border: 1px solid #eee;
  display: inline-block;
  padding: 22px 35px 28px 35px;
  overflow: hidden;
  background-color: #fff;
  font-weight: 600;
  position: relative;
  font-size: 0.7rem;

  @include mq(sm) {
    font-size: 0.8rem;
  }
  @include mq(md) {
    font-size: 0.9rem;
  }
  @include mq(lg) {
    font-size: 1rem;
  }

  &:hover {
    border: 1px solid #ddd;
  }

  .difficulty {
    position: absolute;
    right: 8px;
    font-size: 0.3rem;
    top: 0;
    color: rgb(255, 218, 117);
    .star {
      margin-left: 1px;
    }
  }

  .pron {
    display: inline-block;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }

  .hide {
    opacity: 0;
  }
  .progress {
    height: 3px;
    background-color: rgba(0, 64, 128, 0.3);
    width: 0%;
    position: absolute;
    left: 0;
    transition: 0.7s ease;
    bottom: 0;
  }

  .cleared {
    background-color: #f88;
  }

  .score {
    font-size: 10px;
    position: absolute;
    right: 11px;
    bottom: 9px;
    color: rgba(0, 64, 128, 0.3);
    font-weight: 400;
  }

  .text {
    text-align: center;
  }
}

.target-phoneme {
  color: $main-color;
}
</style>
